module.exports = __webpack_public_path__ + "static/images/congratulations-ash.fcf9a1c.png";